import AsyncSelect from 'react-select/async';
import styled from 'styled-components';

export const AsyncSelectElement = styled(AsyncSelect)`
  background-color: var(--admin-body-color) !important;
  color: var(--admin-text-color);
  #react-select-2-listbox,
  #react-select-3-listbox,
  [id*='-listbox'] {
   {
    background-color: var(--admin-body-color) !important;
    color: var(--admin-text-color);
  }
  #react-select-2-input,
  #react-select-3-input,
  #react-select-4-input,
  #react-select-5-input,
  [id*='-input'] {
    background-color: transparent !important;
    color: var(--admin-text-color);
  }
`;
